/**
 * DownloadCTA - 下载号召区域组件
 * 平台配置项支持：
 *   { name, url, icon, sub }            → 可点击的下载按钮（sub 可自定义副标题）
 *   { name, icon, sub, comingSoon: true } → 显示"即将推出"、不可点击
 */
export class DownloadCTA {
  constructor(options = {}) {
    this.title = options.title || '立即体验';
    this.subtitle = options.subtitle || '';
    this.platforms = options.platforms || [];
    this.className = options.className || '';
  }

  render() {
    const section = document.createElement('section');
    section.className = `download-cta section${this.className ? ` ${this.className}` : ''}`;

    const buttons = this.platforms
      .map((p) => {
        if (p.comingSoon) {
          return `<span class="btn btn--platform btn--soon" aria-disabled="true">
            <span class="btn__icon">${p.icon || ''}</span>
            <span class="btn__text">
              <span class="btn__label">${p.name}</span>
              <span class="btn__sub">${p.sub || '即将推出'}</span>
            </span>
          </span>`;
        }
        return `<a href="${p.url}" class="btn btn--platform" target="_blank" rel="noopener noreferrer">
          <span class="btn__icon">${p.icon || ''}</span>
          <span class="btn__text">
            <span class="btn__label">${p.name}</span>
            <span class="btn__sub">${p.sub || '立即下载'}</span>
          </span>
        </a>`;
      })
      .join('');

    section.innerHTML = `
      <div class="container" style="text-align:center;">
        <h2 class="heading-lg">${this.title}</h2>
        ${this.subtitle ? `<p class="text-muted" style="margin-top:var(--space-4);font-size:var(--text-lg);">${this.subtitle}</p>` : ''}
        <div class="platform-grid">
          ${buttons}
        </div>
      </div>
    `;
    return section;
  }
}
